import { IOrganizations } from "../types/Organisation";

/** Display status of an organization row in the Organizations page / request modal.
 * Adds AWAITING_DOCUMENTS on top of the backend's verificationStatus: a PENDING
 * organization that hasn't uploaded its supporting documents yet isn't reviewable,
 * so it reads as "بانتظار رفع الملفات" instead of "قيد المراجعة". */
export type TOrganizationRequestStatus =
  | "AWAITING_DOCUMENTS"
  | "PENDING"
  | "REJECTED"
  | "VERIFIED";

export const ORGANIZATION_REQUEST_STATUS_LABELS: Record<
  TOrganizationRequestStatus,
  string
> = {
  AWAITING_DOCUMENTS: "بانتظار رفع الملفات",
  PENDING: "قيد المراجعة",
  REJECTED: "مرفوض",
  VERIFIED: "مفعل",
};

/**
 * @param hasDocuments whether the organization uploaded at least one supporting
 * document. `undefined` means "not known yet" (documents still loading) and is
 * treated as missing, so actions stay disabled until we know for certain.
 */
export const getOrganizationRequestStatus = (
  organization?: IOrganizations,
  hasDocuments?: boolean
): TOrganizationRequestStatus => {
  const status = organization?.verificationStatus || "VERIFIED";
  if (status === "PENDING" && !hasDocuments) return "AWAITING_DOCUMENTS";
  return status;
};

/** An admin can only accept/reject a request once the organization has uploaded
 * its documents — there is nothing to review otherwise. */
export const canReviewOrganizationRequest = (
  organization?: IOrganizations,
  hasDocuments?: boolean
): boolean =>
  organization?.verificationStatus === "PENDING" && Boolean(hasDocuments);
